import { ReactNode, createContext, useContext, useEffect, useMemo } from 'react';

import { PublisherReviewService } from '../services/PublisherReviewService';
import { useContentEditorService } from './ContentEditorServiceContext';
import { useInlineCommentManager } from './InlineCommentManagerContext';
import { useMplServiceClient } from './MplServiceClientContext';

const PublisherReviewServiceContext = createContext<PublisherReviewService | undefined>(undefined);

export { PublisherReviewServiceContext };

export function PublisherReviewServiceProvider({ children }: { children: ReactNode }) {
  const mpl = useMplServiceClient();
  const contentEditorService = useContentEditorService();
  const commentManager = useInlineCommentManager();
  const service = useMemo(
    () => new PublisherReviewService(mpl, contentEditorService, commentManager),
    [mpl, contentEditorService, commentManager],
  );

  useEffect(() => {
    return () => {
      service.close();
    };
  }, [service]);

  return (
    <PublisherReviewServiceContext.Provider value={service}>
      {children}
    </PublisherReviewServiceContext.Provider>
  );
}

export function usePublisherReviewService(): PublisherReviewService {
  const context = useContext(PublisherReviewServiceContext);
  if (!context) {
    throw new Error('usePublisherReviewService must be used within PublisherReviewServiceProvider');
  }
  return context;
}
